<template>
  <div class="d-flex" :style="element.style">
    <b-img-lazy v-bind="mainProps" :src="getImageUrl(element.src)"></b-img-lazy>
  </div>
</template>

<script>
import {ENTRYPOINT} from '../../../config/entrypoint'
export default {
  props: {
    element: {
      type: Object,
      required: true
    },
    center: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mainProps: {
        blank: true,
        fluidGrow: false,
        blankColor: '#bbb',
        class: 'm-1',
        center: false
      }
    }
  },
  methods: {
    getImageUrl (src) {
      if (src.startsWith('upload')) {
        return `${ENTRYPOINT}/${src}`
      }
      return src
    }

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/display/imageElement.vue